import Product from './Product';
import {TYPE_JEWELRY} from '../constants/productTypes';

export default class Jewelry extends Product {
  entityType = TYPE_JEWELRY;
}
